/* eslint-disable */

import { rootApi } from '../rootApi';
import { WarrantyClaimStatus } from '../../utils/warrantyClaimsEnums';

function getStatusByActiveIndex(activeIndex) {
    switch (activeIndex) {
        case 0:
            return WarrantyClaimStatus.DRAFT;
        case 1:
            return WarrantyClaimStatus.WAITING;
        case 2:
            return WarrantyClaimStatus.RETURNED;
        case 3:
            return WarrantyClaimStatus.RETURNED_TO_KARSAN;
        case 4:
            return WarrantyClaimStatus.ACCEPTED;
        case 5:
            return WarrantyClaimStatus.REJECTED;
        case 6:
            return null; // tüm talepler
        default:
            return WarrantyClaimStatus.DRAFT;
    }
}

const sanitizeCategory = (val) => {
    if (typeof val === 'string') {
        return val.trim() !== '' ? val : 0;
    }
    return val != null && val !== '' ? val : 0;
};

export const warrantyClaimsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllWarrantyClaims: builder.query({
            query: (params) => {
                const activeIndex = params.status || 0;
                const languageId = params.languageId || 2;
                const { languageId: _, ...paramsWithoutLanguageId } = params;
                return {
                    url: 'v1/warrantyclaims/getlist',
                    method: 'POST',
                    body: {
                        ...paramsWithoutLanguageId,
                        LanguageId: languageId,
                        status: getStatusByActiveIndex(activeIndex),
                        filters: params.filters || null,
                        sorts: params.sorts || null,
                        includeFilterOptions: params.includeFilterOptions || false,
                        filterOptionsColumns: params.filterOptionsColumns || null
                    }
                };
            },
            transformResponse: (response) => {
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data.items)) {
                        return {
                            items: response.data.items,
                            totalCount: response.data.totalCount,
                            filterOptions: response.data.filterOptions || null
                        };
                    }

                    if (Array.isArray(response)) {
                        return response;
                    }
                }

                console.warn('⚠️ Response structure not as expected, returning empty array');
                return { items: [], totalCount: 0, filterOptions: null };
            },
            // Keep track of API state for debugging
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {
                    console.error('❌ getAllPreApprovals query failed:', error);
                }
            },
            providesTags: ['WarrantyClaims']
        }),

        createWarrantyClaims: builder.mutation({
            query: (data) => ({
                url: 'v1/warrantyclaims/add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['WarrantyClaims']
        }),

        getWarrantyClaimsById: builder.query({
            query: ({ id, languageId = 2 }) => ({
                url: `/v1/warrantyclaims/getbyid?Id=${id}&LanguageId=${languageId}`,
                method: 'GET'
            }),
            transformResponse: (response) => response.data,
            providesTags: (result, error, { id }) => {
                if (result) {
                    return [{ type: 'warrantyclaims', id }];
                } else {
                    return [{ type: 'warrantyclaims', id: 'LIST' }];
                }
            }
        }),

        updateWarrantyClaims: builder.mutation({
            query: (data) => {
                const activeIndex = data.status || 0;
                return {
                    url: 'v1/warrantyclaims/update',
                    method: 'POST',
                    body: {
                        ...data,
                        mainCategory: sanitizeCategory(data.mainCategory),
                        secondaryCategory: sanitizeCategory(data.secondCategory),
                        subCategory: sanitizeCategory(data.subCategory),
                        subPartCategory: sanitizeCategory(data.subPartCategory),
                        status: getStatusByActiveIndex(activeIndex),
                        sendToApprovalComment: data.sendToApprovalComment || ''
                    }
                };
            },
            // NOT: 'WarrantyClaims' tag'i buraya eklendi çünkü liste sorgusu (getAllWarrantyClaims)
            // bu tag ile provide ediliyor. Bu olmadan bir talep güncellendiğinde liste sayfası
            // cache'ten eski veriyi göstermeye devam ediyordu (diğer tüm claim mutasyonları -
            // create/delete/approve/return/updateAllocation - zaten bu tag'i invalidate ediyordu).
            invalidatesTags: (result, error, data) => [{ type: 'warrantyclaims', id: data.id }, 'WarrantyClaims']
        }),

        deleteWarrantyClaims: builder.mutation({
            query: (id) => ({
                url: `v1/warrantyclaims/delete`,
                body: { id: id },
                method: 'DELETE'
            }),
            invalidatesTags: ['WarrantyClaims']
        }),

        warrantyClaimsApprovement: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/warrantyclaims/approve',
                    method: 'POST',
                    body: data
                };
            },
            invalidatesTags: (result, error, data) => ['WarrantyClaims', { type: 'warrantyclaims', id: data.id }]
        }),

        warrantyClaimsReturn: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/warrantyclaims/return',
                    method: 'POST',
                    body: data
                };
            },
            invalidatesTags: (result, error, data) => ['WarrantyClaims', { type: 'warrantyclaims', id: data.warrantyClaimId }]
        }),

        bulkApproveSimple: builder.mutation({
            query: (data) => ({
                url: 'v1/warrantyclaims/bulkapprovesimple',
                method: 'POST',
                body: {
                    claimIds: data.claimIds || [],
                    isApproved: data.isApproved ?? true,
                    globalComments: data.globalComments ?? '',
                    alokasyon: data.alokasyon ?? null,
                    allClaims: data.allClaims ?? false
                }
            }),
            invalidatesTags: ['WarrantyClaims']
        }),

        updateAllocation: builder.mutation({
            query: ({ claimId, alokasyon }) => ({
                url: 'v1/warrantyclaims/updateallocation',
                method: 'POST',
                body: {
                    claimId: Number(claimId) || 0,
                    alokasyon: Number(alokasyon) || 0
                }
            }),
            invalidatesTags: (result, error, { claimId }) => ['WarrantyClaims', { type: 'warrantyclaims', id: claimId }]
        }),

        getWarrantyClaimsItemList: builder.query({
            query: ({ warrClaimId, PageSize, PageNumber, LanguageId = 2 }) => ({
                url: `v1/warrantyclaimsitem/getlist`,
                method: 'GET',
                params: {
                    warrClaimId,
                    PageSize,
                    PageNumber,
                    LanguageId
                }
            }),
            providesTags: (result, error, arg) => [{ type: 'WarrantyClaimsItems', id: arg.warrClaimId }]
        }),

        getWarrantyClaimsItemById: builder.query({
            query: ({ id, LanguageId = 2 }) => ({
                url: `v1/warrantyclaimsitem/getbyid`,
                method: 'GET',
                params: {
                    id,
                    LanguageId
                }
            }),
            providesTags: (result, error, arg) => [{ type: 'WarrantyClaimsItem', id: arg.id }]
        }),

        addWarrantyClaimsItem: builder.mutation({
            query: (data) => ({
                url: 'v1/warrantyclaimsitem/add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, data) => ['WarrantyClaims', { type: 'WarrantyClaimsItems', id: data.warrClaimId }, { type: 'WarrantyClaimsTotals', id: data.warrClaimId }]
        }),
        updateWarrantyClaimsItem: builder.mutation({
            query: (data) => ({
                url: 'v1/warrantyclaimsitem/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, data) => ['WarrantyClaims', { type: 'WarrantyClaimsItems', id: data.warrClaimId }, { type: 'WarrantyClaimsTotals', id: data.warrClaimId }]
        }),

        deleteWarrantyClaimsItem: builder.mutation({
            query: (id) => ({
                url: 'v1/warrantyclaimsitem/delete',
                method: 'DELETE',
                body: { id: id }
            }),
            invalidatesTags: (result, error, id) => ['WarrantyClaimsItems', 'WarrantyClaims']
        }),
        updateMaterialCostType: builder.mutation({
            query: (data) => ({
                url: 'v1/warrantyclaimsitem/updatematerialcosttype',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, data) => ['WarrantyClaimsItems', 'WarrantyClaims']
        }),
        getWarrantyClaimsLaborList: builder.query({
            query: ({ WarrantyClaimsId, PageSize, PageNumber, LanguageId = 1 }) => ({
                url: 'v1/warrantyclaimslabor/getlist',
                method: 'GET',
                params: {
                    WarrantyClaimsId,
                    PageSize,
                    PageNumber,
                    LanguageId
                }
            }),
            providesTags: (result, error, arg) => [{ type: 'WarrantyClaimsLabor', id: arg.WarrantyClaimsId }]
        }),

        getWarrantyClaimsLaborById: builder.query({
            query: ({ id, LanguageId = 1 }) => ({
                url: 'v1/warrantyclaimslabor/getbyid',
                method: 'GET',
                params: {
                    id,
                    LanguageId
                }
            }),
            providesTags: (result, error, arg) => [{ type: 'WarrantyClaimsLaborItem', id: arg.id }]
        }),

        addWarrantyClaimsLabor: builder.mutation({
            query: (data, api) => {
                const siteUseId = api?.getState ? api.getState().userParams.siteUseId || 0 : data.siteUseId || 0;
                return {
                    url: 'v1/warrantyclaimslabor/add',
                    method: 'POST',
                    body: {
                        ...data,
                        siteUseId: siteUseId,
                        customerAddressBrandId: 0
                    }
                };
            },
            invalidatesTags: (result, error, data) => [
                { type: 'WarrantyClaimsLabor', id: data.warrClaimId },
                { type: 'WarrantyClaimsTotals', id: data.warrClaimId }
            ]
        }),
        updateWarrantyClaimsLabor: builder.mutation({
            query: (data) => ({
                url: 'v1/warrantyclaimslabor/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, data) => [
                { type: 'WarrantyClaimsLabor', id: data.warrClaimId },
                { type: 'WarrantyClaimsTotals', id: data.warrClaimId }
            ]
        }),

        deleteWarrantyClaimsLabor: builder.mutation({
            query: (id) => ({
                url: 'v1/warrantyclaimslabor/delete',
                method: 'DELETE',
                body: { id: id }
            }),
            invalidatesTags: (result, error, id) => ['WarrantyClaimsLabor', 'WarrantyClaims']
        }),

        // Other Cost endpoints
        getWarrantyClaimsOtherCostList: builder.query({
            query: ({ WarrantyClaimsId, PageSize, PageNumber, LanguageId = 1 }) => ({
                url: 'v1/warrantyclaimsothercost/getlist',
                method: 'GET',
                params: {
                    WarrantyClaimsId,
                    PageSize,
                    PageNumber,
                    LanguageId
                }
            }),
            providesTags: (result, error, arg) => [{ type: 'WarrantyClaimsOtherCost', id: arg.WarrantyClaimsId }]
        }),

        getWarrantyClaimsOtherCostById: builder.query({
            query: ({ id, languageId = 1 }) => ({
                url: `v1/warrantyclaimsothercost/getbyid`,
                method: 'GET',
                params: {
                    Id: id,
                    LanguageId: languageId
                }
            }),
            providesTags: (result, error, arg) => [{ type: 'WarrantyClaimsOtherCost', id: arg.id }]
        }),

        addWarrantyClaimsOtherCost: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/warrantyclaimsothercost/add',
                    method: 'POST',
                    body: data
                };
            },
            invalidatesTags: (result, error, data) => [
                { type: 'WarrantyClaimsOtherCost', id: data.claimId || data.warrClaimId },
                { type: 'WarrantyClaimsTotals', id: data.claimId || data.warrClaimId }
            ]
        }),

        updateWarrantyClaimsOtherCost: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/warrantyclaimsothercost/update',
                    method: 'POST',
                    body: data
                };
            },
            invalidatesTags: (result, error, data) => [
                { type: 'WarrantyClaimsOtherCost', id: data.claimId || data.warrClaimId },
                { type: 'WarrantyClaimsTotals', id: data.claimId || data.warrClaimId }
            ]
        }),

        deleteWarrantyClaimsOtherCost: builder.mutation({
            query: (id) => ({
                url: 'v1/warrantyclaimsothercost/delete',
                method: 'DELETE',
                body: { id: id }
            }),
            invalidatesTags: (result, error, id) => ['WarrantyClaimsOtherCost']
        }),

        // Document Management endpoints
        uploadWarrantyClaimDocument: builder.mutation({
            query: (data) => {
                const formData = new FormData();
                formData.append('file', data.file);
                formData.append('WarrantyClaimId', data.claimId);
                formData.append('description', data.description || '');

                if (data.subModuleType) {
                    formData.append('SubModuleType', parseInt(data.subModuleType));
                }
                if (data.subReferenceId) {
                    formData.append('SubReferenceId', parseInt(data.subReferenceId));
                }

                return {
                    url: 'v1/warrantyclaimsdocument/uploaddocument',
                    method: 'POST',
                    body: formData,
                    formData: true
                };
            },
            invalidatesTags: (result, error, data) => [{ type: 'WarrantyClaimsDocuments', id: data.claimId }]
        }),

        updateWarrantyClaimDocument: builder.mutation({
            query: (data) => {
                const formData = new FormData();
                formData.append('DocumentId', data.DocumentId);
                formData.append('WarrantyClaimId', data.WarrantyClaimId);
                formData.append('Description', data.Description || '');
                formData.append('SubModuleType', parseInt(data.SubModuleType) || 0);
                formData.append('SubReferenceId', parseInt(data.SubReferenceId) || 0);
                if (data.File) {
                    formData.append('File', data.File);
                }

                return {
                    url: 'v1/warrantyclaimsdocument/updatedocument',
                    method: 'PUT',
                    body: formData,
                    formData: true
                };
            },
            invalidatesTags: (result, error, data) => [{ type: 'WarrantyClaimsDocuments', id: data.WarrantyClaimId }]
        }),

        getWarrantyClaimDocumentById: builder.query({
            query: (documentId) => ({
                url: `v1/warrantyclaimsdocument/GetDocumentById/${documentId}`,
                method: 'GET'
            }),
            providesTags: (result, error, documentId) => [{ type: 'WarrantyClaimDocument', id: documentId }]
        }),

        deleteWarrantyClaimDocument: builder.mutation({
            query: ({ id, documentId }) => ({
                url: 'v1/warrantyclaimsdocument/deletedocument',
                method: 'DELETE',
                body: {
                    id: id, // warrantyId
                    documentId: documentId // documentId
                }
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'WarrantyClaimsDocuments', id }]
        }),

        getWarrantyClaimDocumentsById: builder.query({
            query: (claimId) => ({
                url: `v1/warrantyclaimsdocument/getdocumentsbyid`,
                method: 'GET',
                params: { id: claimId }
            }),
            providesTags: (result, error, claimId) => [{ type: 'WarrantyClaimsDocuments', id: claimId }]
        }),

        downloadAllWarrantyClaimDocuments: builder.mutation({
            query: (claimId) => ({
                url: `v1/warrantyclaimsdocument/downloadalldocuments?WarrantyClaimId=${claimId}`,
                method: 'GET',
                responseHandler: async (response) => {
                    if (!response.ok) {
                        // Hata durumunda JSON parse et
                        const errorData = await response.json();
                        throw new Error(errorData.message || 'Download failed');
                    }
                    return response.blob();
                },
                cache: 'no-cache'
            })
        }),

        // Video Management endpoints
        getWarrantyClaimVideos: builder.query({
            query: ({ claimId, includeInactive = false, generateDownloadUrls = true, urlExpirationMinutes = 60 }) => ({
                url: `/api/warranty-claims/${claimId}/videos`,
                method: 'GET',
                params: { includeInactive, generateDownloadUrls, urlExpirationMinutes }
            }),
            providesTags: (result, error, { claimId }) => [{ type: 'WarrantyClaimVideos', id: claimId }]
        }),

        generateVideoUploadUrl: builder.mutation({
            query: ({ claimId, fileName, fileSize, title, description, expirationMinutes = 30 }) => ({
                url: `/api/warranty-claims/${claimId}/videos/generate-upload-url`,
                method: 'POST',
                body: { fileName, fileSize, title, description, expirationMinutes }
            })
        }),

        completeVideoUpload: builder.mutation({
            query: ({ claimId, videoId, durationSeconds }) => ({
                url: `/api/warranty-claims/${claimId}/videos/complete-upload`,
                method: 'POST',
                body: { videoId, durationSeconds }
            }),
            invalidatesTags: (result, error, { claimId }) => [{ type: 'WarrantyClaimVideos', id: claimId }]
        }),

        deleteWarrantyClaimVideo: builder.mutation({
            query: ({ claimId, videoId, hardDelete = false }) => ({
                url: `/api/warranty-claims/${claimId}/videos/${videoId}`,
                method: 'DELETE',
                params: { hardDelete }
            }),
            invalidatesTags: (result, error, { claimId }) => [{ type: 'WarrantyClaimVideos', id: claimId }]
        }),

        //ChasisInfo
        //Buraya endpoint metodu gelecek
        getWarrantyClaimsListByChassis: builder.query({
            query: ({ ChassisNo, PageSize = 10, PageNumber = 1 }) => {
                return {
                    url: `v1/warrantyclaims/getclaimlistbychassis`,
                    method: 'GET',
                    params: {
                        ChassisNo,
                        PageNumber,
                        PageSize
                    }
                };
            },
            providesTags: (result, error, arg) => [{ type: 'WarrantyClaimsItems', id: arg.warrClaimId }]
        }),

        getWarrantyClaimsListBySapDealerId: builder.query({
            query: ({ sapDealerId }) => {
                return {
                    url: `v1/warrantyclaims/getclaimcountbysapdealerid`,
                    method: 'GET',
                    params: {
                        SapDealerId: sapDealerId
                    }
                };
            },
            providesTags: () => []
        }),

        calculateWarrantyClaimTotals: builder.query({
            query: ({ warrantyClaimId }) => {
                return {
                    url: `v1/warrantyclaims/calculatetotals`,
                    method: 'GET',
                    params: {
                        warrantyClaimId: warrantyClaimId
                    }
                };
            },
            providesTags: (result, error, { warrantyClaimId }) => [{ type: 'WarrantyClaimsTotals', id: warrantyClaimId }]
        }),

        getChassisItems: builder.query({
            query: ({ Id, PageSize, PageNumber, LanguageId = 2 }) => ({
                url: `v1/warrantyclaims/getChassisItems`,
                method: 'GET',
                params: {
                    Id,
                    PageSize,
                    PageNumber,
                    LanguageId
                }
            }),
            providesTags: (result, error, arg) => [{ type: 'getChassisItems', id: arg.Id }]
        }),
        getChassisLabor: builder.query({
            query: ({ Id, PageSize, PageNumber, LanguageId = 2 }) => ({
                url: `v1/warrantyclaims/getChassisLabor`,
                method: 'GET',
                params: {
                    Id,
                    PageSize,
                    PageNumber,
                    LanguageId
                }
            }),
            providesTags: (result, error, arg) => [{ type: 'getChassisLabor', id: arg.Id }]
        }),
        getChassisOtherCost: builder.query({
            query: ({ Id, PageSize, PageNumber, LanguageId = 2 }) => ({
                url: `v1/warrantyclaims/getChassisOtherCost`,
                method: 'GET',
                params: {
                    Id,
                    PageSize,
                    PageNumber,
                    LanguageId
                }
            }),
            providesTags: (result, error, arg) => [{ type: 'getChassisOtherCost', id: arg.Id }]
        }),

        getWarrantyClaimsHistory: builder.query({
            query: ({ id, pageNumber = 0, pageSize = 100, languageId = 2 }) => ({
                url: 'v1/warrantyclaims/gethistorybyid',
                method: 'POST',
                body: {
                    id,
                    pageNumber,
                    pageSize,
                    languageId
                }
            }),
            transformResponse: (response) => {
                if (response && typeof response === 'object') {
                    // Check for nested data structure: response.data.data.items
                    if (response.data && response.data.data && Array.isArray(response.data.data.items)) {
                        return response.data.data.items;
                    }

                    // Check for direct data.items structure
                    if (response.data && Array.isArray(response.data.items)) {
                        return response.data.items;
                    }

                    // Check for direct array in data
                    if (response.data && Array.isArray(response.data)) {
                        return response.data;
                    }

                    // Check if response itself is an array
                    if (Array.isArray(response)) {
                        return response;
                    }
                }

                return [];
            },
            providesTags: (result, error, { id }) => [{ type: 'WarrantyClaimsHistory', id }]
        }),
        getApprovalCommentsByClaimId: builder.query({
            query: ({ claimId }) => ({
                url: 'v1/warrantyclaims/GetCommentsByClaimId',
                method: 'GET',
                params: { ClaimId: claimId }
            }),
            transformResponse: (response) => {
                if (response?.data?.items && Array.isArray(response.data.items)) {
                    return response.data;
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: (result, error, arg) => [{ type: 'WarrantyClaims', id: arg?.claimId }]
        }),

        getClaimCardPdfData: builder.query({
            query: ({ warrClaimsNo, itemCode }) => ({
                url: 'v1/warrantyclaimsitem/GetClaimCardPdfData',
                method: 'GET',
                params: { warrClaimsNo, itemCode }
            }),
            transformResponse: (response) => {
                if (response && typeof response === 'object') {
                    if (response.isSuccessful === true && response.httpStatusCode === 200) {
                        return {
                            success: true,
                            data: response.data
                        };
                    } else if (response.isSuccessful === false) {
                        throw new Error(response.errorMessage || 'API_FETCH_PDF_DATA_ERROR');
                    }
                }
                return {
                    success: true,
                    data: response?.data || {}
                };
            },
            transformErrorResponse: (response) => {
                return {
                    status: response?.status || 'UNKNOWN_ERROR',
                    data: response?.data,
                    errorMessage: response?.data?.errorMessage || response?.data?.message || 'API_FETCH_PDF_DATA_GENERAL_ERROR'
                };
            }
        }),
        getItemReplacementDetails: builder.query({
            query: ({ ChassisNo, ItemCode, LanguageId = 2 }) => ({
                url: 'v1/warrantyclaimsitem/getitemreplacementdetails',
                method: 'GET',
                params: { ChassisNo, ItemCode, LanguageId }
            }),
            transformResponse: (response) => response
        }),

        getWarrantyClaimsOtherCostItemPdf: builder.query({
            query: ({ claimId }) => ({
                url: 'v1/warrantyclaimsothercost/getitempdf',
                method: 'GET',
                params: { ClaimId: claimId }
            }),
            transformResponse: (response) => {
                if (response && typeof response === 'object') {
                    if (response.isSuccessful === true && response.httpStatusCode === 200) {
                        return {
                            success: true,
                            data: response.data
                        };
                    } else if (response.isSuccessful === false) {
                        throw new Error(response.errorMessage || 'API_FETCH_PDF_DATA_ERROR');
                    }
                }
                return {
                    success: true,
                    data: response?.data || {}
                };
            },
            transformErrorResponse: (response) => {
                return {
                    status: response?.status || 'UNKNOWN_ERROR',
                    data: response?.data,
                    errorMessage: response?.data?.errorMessage || response?.data?.message || 'API_FETCH_PDF_DATA_GENERAL_ERROR'
                };
            }
        }),

        getExternalParts: builder.query({
            query: ({ PageSize = 10, PageNumber = 1, dealerId, dealerAddressId, SearchText }) => ({
                url: `v1/warrantyclaimsitem/GetExternalParts`,
                method: 'GET',
                params: {
                    PageSize,
                    PageNumber,
                    DealerId: dealerId,
                    DealerAddressId: dealerAddressId,
                    ...(SearchText && { SearchText })
                }
            }),
            providesTags: (result) => [{ type: 'ExternalParts', id: 'LIST' }]
        }),

        getAvailableWarrantyTypes: builder.query({
            query: ({ ChassisNo, ClaimDate, KmInformation, LanguageId = 1 }) => ({
                url: 'v1/warrantyclaims/getavailablewarrantytypes',
                method: 'GET',
                params: {
                    ChassisNo,
                    FailureDate: ClaimDate,
                    KmInformation,
                    LanguageId
                }
            }),
            transformResponse: (response) => {
                if (response && typeof response === 'object' && response.data) {
                    return {
                        warrantyTypes: response.data.warrantyTypes || [],
                        subWarrantyTypes: response.data.subWarrantyTypes || [],
                        isStandardWarrantyActive: response.data.isStandardWarrantyActive || false,
                        standardWarrantyEndDate: response.data.standardWarrantyEndDate || null,
                        standardWarrantyMileageLimit: response.data.standardWarrantyMileageLimit || 0,
                        warningMessage: response.data.warningMessage || null
                    };
                }
                return {
                    warrantyTypes: [],
                    subWarrantyTypes: [],
                    isStandardWarrantyActive: false,
                    standardWarrantyEndDate: null,
                    standardWarrantyMileageLimit: 0,
                    warningMessage: null
                };
            },
            providesTags: ['AvailableWarrantyTypes']
        }),

        calculateLaborCost: builder.query({
            query: ({ WarrClaimId, LaborId, LaborCode, SiteUseId, WarrantyType, LaborTime, Quantity }) => ({
                url: 'v1/WarrantyClaimsLabor/CalculateLaborCost',
                method: 'GET',
                params: {
                    WarrClaimId,
                    LaborId,
                    ...(LaborCode && { LaborCode }),
                    SiteUseId,
                    WarrantyType,
                    ...(LaborTime !== undefined && { LaborTime }),
                    ...(Quantity !== undefined && { Quantity })
                }
            }),
            transformResponse: (response) => {
                if (response && response.isSuccessful && response.data) {
                    return response.data;
                }
                return null;
            }
        }),

        addServiceBulletinItems: builder.mutation({
            query: ({ claimId, bulletNo, clearExistingItems = true }) => ({
                url: 'v1/warrantyclaims/addservicebulletinitems',
                method: 'POST',
                body: {
                    claimId,
                    bulletNo,
                    clearExistingItems
                }
            }),
            invalidatesTags: (result, error, { claimId }) => [
                { type: 'WarrantyClaimsItems', id: claimId },
                { type: 'WarrantyClaimsLabor', id: claimId },
                { type: 'WarrantyClaimsOtherCost', id: claimId },
                { type: 'WarrantyClaimsTotals', id: claimId },
                'WarrantyClaims'
            ]
        }),

        addDealerPackageItems: builder.mutation({
            query: ({ claimId, dealerPackageId, packageWarrantyType, clearExistingItems = true }) => ({
                url: 'v1/warrantyclaims/adddealerpackageitems',
                method: 'POST',
                body: {
                    claimId,
                    dealerPackageId,
                    packageWarrantyType,
                    clearExistingItems
                }
            }),
            invalidatesTags: (result, error, { claimId }) => [
                { type: 'WarrantyClaimsItems', id: claimId },
                { type: 'WarrantyClaimsLabor', id: claimId },
                { type: 'WarrantyClaimsOtherCost', id: claimId },
                { type: 'WarrantyClaimsTotals', id: claimId },
                'WarrantyClaims'
            ]
        }),

        getWarrantyWarningByChassis: builder.query({
            query: ({ chassisNo, claimId }) => ({
                url: 'v1/WarrantyClaims/GetWarrantyWarningByChassis',
                method: 'GET',
                params: { chassisNo, claimId }
            }),
            transformResponse: (response) => response?.data || null
        }),

        changeRejectedOrAcceptedStatus: builder.mutation({
            query: ({ claimId, newStatus, reason }) => ({
                url: 'v1/warrantyclaims/changerejectedoracceptedstatus',
                method: 'POST',
                body: {
                    claimId: Number(claimId),
                    newStatus: Number(newStatus),
                    reason: reason || ''
                }
            }),
            invalidatesTags: (result, error, { claimId }) => ['WarrantyClaims', { type: 'warrantyclaims', id: claimId }, { type: 'WarrantyClaimsHistory', id: claimId }]
        }),

        exportWarrantyClaims: builder.query({
            query: (params) => {
                const activeIndex = params.status || 0;
                const languageId = params.languageId || 2;
                const { languageId: _, ...paramsWithoutLanguageId } = params;
                return {
                    url: 'v1/warrantyclaims/exporttoexcel',
                    method: 'POST',
                    body: {
                        ...paramsWithoutLanguageId,
                        LanguageId: languageId,
                        status: getStatusByActiveIndex(activeIndex),
                        filters: params.filters || null,
                        sorts: params.sorts || null
                    }
                };
            },
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, fileSize } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, fileSize };
                }
                throw new Error(response?.errorMessage || 'Export failed');
            }
        }),
        getWarrantyClaimsStatusCounts: builder.query({
            query: (params) => {
                const languageId = params.languageId || 2;
                const { languageId: _, status: __, pageNumber, pageSize, sorts, ...rest } = params;
                return {
                    url: 'v1/warrantyclaims/getstatuscounts',
                    method: 'POST',
                    body: {
                        ...rest,
                        LanguageId: languageId,
                        filters: params.filters || null
                    }
                };
            },
            transformResponse: (response) => {
                if (response?.data?.statusCounts && Array.isArray(response.data.statusCounts)) {
                    const map = {};
                    response.data.statusCounts.forEach((i) => {
                        map[i.status] = i.count;
                    });
                    return map;
                }
                return {};
            },
            providesTags: ['WarrantyClaims']
        })
    })
});

export const {
    useGetAllWarrantyClaimsQuery,
    useCreateWarrantyClaimsMutation,
    useGetWarrantyClaimsByIdQuery,
    useUpdateWarrantyClaimsMutation,
    useDeleteWarrantyClaimsMutation,
    useWarrantyClaimsApprovementMutation,
    useWarrantyClaimsReturnMutation,
    useBulkApproveSimpleMutation,
    useUpdateAllocationMutation,
    useGetWarrantyClaimsItemListQuery,
    useGetWarrantyClaimsItemByIdQuery,
    useAddWarrantyClaimsItemMutation,
    useUpdateWarrantyClaimsItemMutation,
    useDeleteWarrantyClaimsItemMutation,
    useGetWarrantyClaimsLaborListQuery,
    useGetWarrantyClaimsLaborByIdQuery,
    useAddWarrantyClaimsLaborMutation,
    useUpdateWarrantyClaimsLaborMutation,
    useDeleteWarrantyClaimsLaborMutation,
    useAddWarrantyClaimsOtherCostMutation,
    useGetWarrantyClaimsOtherCostByIdQuery,
    useGetWarrantyClaimsOtherCostListQuery,
    useUpdateWarrantyClaimsOtherCostMutation,
    useDeleteWarrantyClaimsOtherCostMutation,
    useUploadWarrantyClaimDocumentMutation,
    useUpdateWarrantyClaimDocumentMutation,
    useGetWarrantyClaimDocumentByIdQuery,
    useLazyGetWarrantyClaimDocumentByIdQuery,
    useDeleteWarrantyClaimDocumentMutation,
    useGetWarrantyClaimDocumentsByIdQuery,
    useDownloadAllWarrantyClaimDocumentsMutation,
    useGetWarrantyClaimsListByChassisQuery,
    useLazyGetWarrantyClaimsListByChassisQuery,
    useGetWarrantyClaimsListBySapDealerIdQuery,
    useCalculateWarrantyClaimTotalsQuery,
    useGetChassisItemsQuery,
    useGetChassisLaborQuery,
    useGetChassisOtherCostQuery,
    useGetWarrantyClaimsHistoryQuery,
    useGetApprovalCommentsByClaimIdQuery,
    useLazyGetClaimCardPdfDataQuery,
    useLazyGetItemReplacementDetailsQuery,
    useLazyGetWarrantyClaimsOtherCostItemPdfQuery,
    useGetExternalPartsQuery,
    useGetAvailableWarrantyTypesQuery,
    useLazyCalculateLaborCostQuery,
    useAddServiceBulletinItemsMutation,
    useAddDealerPackageItemsMutation,
    useLazyExportWarrantyClaimsQuery,
    useGetWarrantyClaimVideosQuery,
    useGenerateVideoUploadUrlMutation,
    useCompleteVideoUploadMutation,
    useDeleteWarrantyClaimVideoMutation,
    useGetWarrantyWarningByChassisQuery,
    useUpdateMaterialCostTypeMutation,
    useChangeRejectedOrAcceptedStatusMutation,
    useGetWarrantyClaimsStatusCountsQuery
} = warrantyClaimsApi;
